import React from "react";
import { useTheme } from "@mui/material/styles";
import { PeekButton } from "@piiqtechnologies/ui-components";
export const LinkButton = ({ onClick, disabled, label, children, startIcon, endIcon, underline = true, sx, disableRipple = true, }) => {
    const theme = useTheme();
    const additionalSx = Array.isArray(sx) ? sx : sx ? [sx] : [];
    const decoration = underline ? "underline" : "none";
    return (React.createElement(PeekButton, { color: "primary", disableRipple: disableRipple, disabled: disabled, variant: "outlined", onClick: onClick, startIcon: startIcon, endIcon: endIcon, sx: [
            {
                width: "fit-content",
                alignSelf: "center",
                border: "0 !important",
                p: 0,
                textDecoration: decoration,
                "& .MuiButton-endIcon": {
                    color: "inherit",
                },
                ":hover": {
                    backgroundColor: "transparent",
                    color: theme.palette.secondary.main,
                },
            },
            ...additionalSx,
        ] }, children !== null && children !== void 0 ? children : label));
};
export default LinkButton;
